<script>
  import Contained from '../components/button-contained.svelte'
  import Outlined from '../components/button-outline.svelte'

  import {
    createEventDispatcher
  } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<div class="overlay">
  <div class="card modal">
    <h6>Resume Show?</h6>
    <p>It looks like you've already started playing this show before. Would you like to resume where you left off?</p>
    <Contained ref="resume" on:pressed="{(e) => dispatch('selected', e.detail.ref)}" text=Resume />
    <Outlined ref="restart" on:pressed="{(e) => dispatch('selected', e.detail.ref)}" text="restart" />
  </div>

</div>

<style>
  .modal {
    width: 70vw;
    margin: 80px 10vw;
  }

  h6 {
    margin: 0 0 15px 0;
  }

  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1500;
    background-color: rgba(32, 32, 32, 0.7)
  }
</style>
